/* eslint-disable jsx-a11y/anchor-is-valid */
/*

tailwind.config = {
  theme: {
    extend: {
      fontFamily: {
        display: ["DM Serif Display", "serif"],
        body: ["Inter", "sans-serif"],
      },
      colors: {
        "hepard-teal": "var(--color-hepard-teal)",
        "hepard-blue": "var(--color-hepard-blue)",
        "hepard-green": "var(--color-hepard-green)",
        "hepard-light-gray": "var(--color-hepard-light-gray)",
        "hepard-dark-gray": "var(--color-hepard-dark-gray)",
      },
    },
  },
};
<style type="text/tailwindcss">
      @layer theme {
        :root {
          --color-hepard-teal: #008080;
          --color-hepard-blue: #004B8D;
          --color-hepard-green: #3CB371;
          --color-hepard-light-gray: #F0F4F8;
          --color-hepard-dark-gray: #334155;
        }
        .text-gradient {
          background: linear-gradient(to right, var(--color-hepard-teal), var(--color-hepard-blue));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .bg-gradient-subtle {
           background: linear-gradient(135deg, var(--color-hepard-teal) 0%, var(--color-hepard-blue) 100%);
        }
        .nav-link::after {
          content: '';
          position: absolute;
          width: 100%;
          transform: scaleX(0);
          height: 2px;
          bottom: -4px;
          left: 0;
          background: linear-gradient(to right, var(--color-hepard-teal), var(--color-hepard-blue));
          transform-origin: bottom right;
          transition: transform 0.3s ease-out;
        }
        .nav-link:hover::after {
          transform: scaleX(1);
          transform-origin: bottom left;
        }
      }
    </style>
		*/
const PartDesign = () => {
  return (
    <html lang="en">
      <head>
        <meta charset="utf-8" />
        <meta content="width=device-width, initial-scale=1.0" name="viewport" />
        <title>HEPARD Network Landing Page Variant 2</title>
        <link href="https://fonts.googleapis.com" rel="preconnect" />
        <link href="https://fonts.gstatic.com" rel="preconnect" />
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Serif+Display&amp;family=Inter:wght@400;500;600&amp;display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&amp;display=swap"
          rel="stylesheet"
        />
        <script src="https://cdn.tailwindcss.com?plugins=forms,typography"></script>
      </head>
      <body className="font-body bg-white text-hepard-dark-gray antialiased">
        <div className="min-h-screen flex flex-col">
          <header className="w-full absolute top-0 z-50 py-6">
            <div className="container mx-auto px-6">
              <div className="flex items-center justify-between">
                <a className="flex items-center gap-3" href="#">
                  <img
                    alt="HEPARD Network Logo with a medical cross and world map elements"
                    className="h-10 w-10"
                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuAzS2TgBLYK6Hva3t_Y5t-NPmVjRLp4cobXDtAMxrfV-Ah8u4_9NxBdQQi2Jg203QWvGXknBStlvL5OQi2bNF6KeoLWoB19-IgtKq50O6bng91aejF8VobfjSlEb6UpCnpLepTv7-sEuGk-fGUJLZbmyatI5lfzS2TLW6vShL0rHCt0ggBJRPPn6dmCHIc5E237iV0rbiPxHIeQCPrXfL1dq0X8tWdLEDqidVNDwyDDdy_ELZuyQMfrfNGhc3dX5WwNcWbEcXv6Q7IY"
                  />
                  <span className="text-2xl font-bold tracking-tight text-hepard-dark-gray">
                    HEPARD
                  </span>
                </a>
                <nav className="hidden md:flex items-center gap-8 group">
                  <a
                    className="relative text-hepard-dark-gray hover:text-hepard-blue font-medium transition-colors nav-link"
                    href="#"
                  >
                    About the Project
                  </a>
                  <a
                    className="relative text-hepard-dark-gray hover:text-hepard-blue font-medium transition-colors nav-link"
                    href="#"
                  >
                    PhD Projects
                  </a>
                  <a
                    className="relative text-hepard-dark-gray hover:text-hepard-blue font-medium transition-colors nav-link"
                    href="#"
                  >
                    News
                  </a>
                  <a
                    className="relative text-hepard-dark-gray hover:text-hepard-blue font-medium transition-colors nav-link"
                    href="#"
                  >
                    Diversity
                  </a>
                  <a
                    className="relative text-hepard-dark-gray hover:text-hepard-blue font-medium transition-colors nav-link"
                    href="#"
                  >
                    Contact
                  </a>
                </nav>
                <button className="md:hidden text-slate-600">
                  <span className="material-symbols-outlined">menu</span>
                </button>
              </div>
            </div>
          </header>
          <main className="flex-grow">
            <section className="pt-32 pb-20 bg-hepard-light-gray">
              <div className="container mx-auto px-6">
                <div className="grid lg:grid-cols-2 gap-16 items-center">
                  <div>
                    <span className="inline-block mb-4 text-sm font-semibold tracking-wider uppercase text-hepard-teal">
                      Health Economic Policy with Real World Data
                    </span>
                    <h1 className="font-display text-5xl md:text-6xl text-hepard-dark-gray leading-tight">
                      Forging a path to
                      <br />
                      <span className="text-gradient">health equity</span> in
                      Europe.
                    </h1>
                    <p className="mt-6 text-lg text-slate-600 max-w-lg">
                      HEPARD is a doctoral network uniting health economics,
                      public health, and advanced data analytics to address
                      persistent health inequalities.
                    </p>
                    <div className="mt-10 flex items-center gap-6">
                      <a
                        className="bg-gradient-subtle text-white font-semibold py-3 px-8 rounded-full shadow-lg shadow-hepard-teal/20 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                        href="#"
                      >
                        Explore PhD Projects
                      </a>
                      <a
                        className="font-semibold text-hepard-dark-gray group flex items-center gap-2 hover:text-hepard-blue transition-colors"
                        href="#"
                      >
                        <span>Learn More</span>
                        <span className="material-symbols-outlined transition-transform duration-300 group-hover:translate-x-1">
                          arrow_forward
                        </span>
                      </a>
                    </div>
                  </div>
                  <div className="hidden lg:block">
                    <div className="aspect-[1/1] w-full max-w-md mx-auto relative">
                      <div className="absolute inset-0 bg-gradient-to-br from-hepard-light-gray to-slate-200 rounded-full blur-2xl opacity-50"></div>
                      <img
                        alt="Abstract representing data and health"
                        className="relative w-full h-full object-cover rounded-full shadow-2xl shadow-slate-300/60"
                        src="https://lh3.googleusercontent.com/aida-public/AB6AXuAHPlnlnt1k4pB8SQgkxH0spRubevUhXaGPUZj4WAHoeazVZN01QFSMfxC2AQm2l_4QWanVRbVif4TuVp1gVK34KgBo2dUL4oYgipscOUJDQcdbI3sQhDtsulsHnTRhe4IRbX5nLd6CCk5L5ltk6y0A3VJv4KtXQ3b3Jxw8huzZxFFQ-z2iBRnRwI2VHGPTGcOvbSwYWsmNGQ3kXFpGQl5iZXOfwu5MpiLtsBSROoPh91xwVRj_ffrxHWNIiHLIDpL4NVR2_QK25WDv"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="py-24 sm:py-32">
              <div className="container mx-auto px-6">
                <div className="max-w-3xl mx-auto text-center mb-16">
                  <h2 className="font-display text-4xl md:text-5xl text-hepard-dark-gray">
                    Our Core Pillars
                  </h2>
                  <p className="mt-4 text-lg text-slate-600">
                    We build our research on a foundation of three
                    interconnected disciplines, fostering innovation and
                    creating a holistic impact on public health policy.
                  </p>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                  <div className="flex items-start gap-6">
                    <div className="bg-gradient-subtle text-white rounded-full w-12 h-12 flex-shrink-0 flex items-center justify-center mt-1">
                      <span className="material-symbols-outlined">
                        payments
                      </span>
                    </div>
                    <div>
                      <h3 className="text-xl font-display text-hepard-dark-gray mb-2">
                        Health Economics
                      </h3>
                      <p className="text-slate-600">
                        Analyzing the economic factors influencing health
                        outcomes and policy effectiveness to ensure sustainable
                        and equitable solutions.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-6">
                    <div className="bg-gradient-subtle text-white rounded-full w-12 h-12 flex-shrink-0 flex items-center justify-center mt-1">
                      <span className="material-symbols-outlined">public</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-display text-hepard-dark-gray mb-2">
                        Public Health
                      </h3>
                      <p className="text-slate-600">
                        Focusing on population-level health, we identify
                        determinants of health inequalities and design targeted
                        interventions.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-6">
                    <div className="bg-gradient-subtle text-white rounded-full w-12 h-12 flex-shrink-0 flex items-center justify-center mt-1">
                      <span className="material-symbols-outlined">
                        analytics
                      </span>
                    </div>
                    <div>
                      <h3 className="text-xl font-display text-hepard-dark-gray mb-2">
                        Data Analytics
                      </h3>
                      <p className="text-slate-600">
                        Leveraging real-world data and advanced analytical
                        methods to generate robust evidence for informed
                        policymaking.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="bg-hepard-light-gray">
              <div className="container mx-auto px-6">
                <div className="grid md:grid-cols-2 items-center gap-12 md:gap-20">
                  <div className="py-16 md:py-24">
                    <span className="inline-block mb-4 text-sm font-semibold tracking-wider uppercase text-hepard-teal">
                      Doctoral Training
                    </span>
                    <h2 className="font-display text-4xl md:text-5xl text-hepard-dark-gray leading-tight">
                      Training the Next Generation of Health Policy Leaders.
                    </h2>
                    <p className="mt-6 text-lg text-slate-600">
                      Our doctoral network provides unparalleled training,
                      equipping researchers with the multidisciplinary skills
                      needed to tackle Europe's most pressing health challenges
                      and translate research into impactful policy.
                    </p>
                    <a
                      className="mt-8 inline-flex items-center gap-2 font-semibold text-hepard-blue group"
                      href="#"
                    >
                      <span>View All PhD Projects</span>
                      <span className="material-symbols-outlined transition-transform duration-300 group-hover:translate-x-1">
                        arrow_forward
                      </span>
                    </a>
                  </div>
                  <div className="h-full w-full hidden md:block">
                    <img
                      alt="A researcher working on a laptop with data visualizations."
                      className="w-full h-full object-cover"
                      src="https://lh3.googleusercontent.com/aida-public/AB6AXuBjnvK_uGUv9cW6-LC7VKdf614sTz_UDSjFSBFxhmfeQWpBwLnEaiY0AkjTCe3Phy3vcchuyc49wGM1ZF49S8cNcH5IiWg4Hzm4qBl9MKduOVeXeYSokaid21Xqh5nm6EjVPfExLRIcikteO_F21vTpImtUti0jCH7-OIkRsecBhc8HkPsrhOjkrqFq7bRq089hZkUdkTTLmsmoiI1dNn4b9mXCQiLoZda_tSsbF8iHtja1dX_i1wfH3TOOzw_a9pBEeQvGtSKWuPLc"
                    />
                  </div>
                </div>
              </div>
            </section>
          </main>
        </div>
      </body>
    </html>
  );
};
export default PartDesign;
